import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'

class Container extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  }

  static defaultProps = {
    open: false,
    cancelText: 'Cancel',
  }

  static styles = () => ({
  })

  render() {
    const {
      title,
      description,
      cancelText,
      confirmText,
      onCancel,
      onConfirm,
      ...props
    } = this.props
    return (
      <Dialog
        onClose={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...props}
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>
            {cancelText}
          </Button>
          <Button onClick={onConfirm} color="secondary" variant="contained">
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(Container.styles)(Container)
